/** @format */

import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import SignUpPage from "./pages/Auth/SignUpPage";
import "./asset/Fonts/Poppins-Bold.ttf";
import "./asset/Fonts/Poppins-Medium.ttf";
import "./asset/Fonts/Poppins-Regular.ttf";
import "./asset/Fonts/Poppins-SemiBold.ttf";
import "react-toastify/dist/ReactToastify.css";
import Confirm from "./pages/Auth/Confirm";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import { ToastContainer } from "react-toastify";
import React, { useEffect, useRef, useState } from "react";
import DeveloperApi from "./pages/developer-api/Index";
import TradeAssistant from "./pages/trade-assistant";
import Help from "./pages/Help/Index";
import {
  saveTelegramAuthData,
  setLoginProcessToTelegram,
  setToken,
  setUserData,
} from "./redux/main/action/main";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import PreviousEmail from "./pages/alert-system/previousEmail";
import Profile from "./pages/profile";
import { getProfileData } from "./redux/profile/actions";
import StartWizard from "./shared/StartWizard";
import ExpiredPage from "./shared/ExpiredPage";
import ComingSoon from "./components/ComingSoon";
import moment from "moment";
import RatingModal from "./shared/RatingModal";
import BotAndAutomation from "./pages/Bot/BotAndAutomation";
import BacktestReport from "./components/bot/bot-backtest/BacktestReport";
import WelcomePage from "./pages/WelcomePage";
import NewInsight from "./pages/new-insight/NewInsight";
import AlertSystem from "./pages/alert-system/AlertSystem";
import TelegramAuthentication from "./pages/TelegramAuthentication";
import TokenExpired from "./pages/TokenExpired";
import MiniDashboard from "./components/mini-app/MiniDashboard";
import MiniAISignals from "./components/mini-app/MiniAISignals";
import MiniBots from "./components/mini-app/MiniBots";
import PricingBillingIndex from "./pages/pricing-plan/PricingBillingIndex";
import MiniPricingPlan from "./components/mini-app/MiniPricingPlan";
import { getPricingPlan } from "./redux/pricing-plan/action";
import CreateBotProcess from "./components/mini-app/mini-bots/CreateBotProcess";
import { getTrustedIps } from "./redux/exchange/actions";
import MiniAppAllBots from "./components/mini-app/mini-bots/MiniAppAllBots";
import MiniPortfolio from "./components/mini-app/MiniPortfolio";
import MiniSettings from "./components/mini-app/MiniSettings";
import { getTelegramBotToken } from "./redux/alert-system/actions";
import "react-lazy-load-image-component/src/effects/blur.css";
import LoginPage from "./pages/Auth/LoginPage";
import VerifyUserLocation from "./pages/VerifyUserLocation";
import useDeleteLocalStorageItemOnRefresh from "./hooks/useDeleteLocalStorageItemOnRefresh";
import useActiveTabInterval from "./hooks/useActiveTabInterval";
import NewDashboard from "./pages/new-dashboard/NewDashboard";
import RefreshToken from "./pages/RefreshToken";
import {
  clearLocalStorage,
  expiredTokenHandler,
  isValidSession,
  isValidUserData,
} from "./utility/helper";
import ExchangePortfolio from "./pages/exchange-portfolio/ExchangePortfolio";
import AuthRedirectProcess from "./pages/AuthRedirectProcess";
import MiniBotsPool from "./components/mini-app/MiniBotsPool";
import MiniAppConfirmPage from "./components/mini-app/auth/MiniAppConfirmPage";
import MiniAppResendConfirmationCode from "./components/mini-app/auth/MiniAppResendConfirmationCode";

function App() {
  const { data } = useSelector((state) => state.dashboardData);
  const router = useNavigate();
  const location = useLocation();
  const {
    main: { token, userData },
    exchangeState: { trustedIps, getTrustedIpsStatus },
    alertSystem: { telegramBotToken, telegramBotTokenStatus },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [registeredEmail, setRegisteredEmail] = useState("");
  const [profileDataDispatched, setProfileDataDispatched] = useState(false);
  const [params] = useSearchParams();

  // key for handling user authentication when is redirecting from other platform
  const isRedirecting =
    params.get("authToken") || localStorage.getItem("authToken");

  // delete live suggestion key on local storage
  useDeleteLocalStorageItemOnRefresh([
    "live-suggestions-for-others",
    "live-suggestions-for-ai",
  ]);

  const shouldRunActiveTabInterval =
    !location?.pathname?.includes("telegram-authentication") &&
    !location?.pathname?.includes("refresh-token") &&
    !location?.pathname?.includes("auth");

  // Custom hook for active tab interval - executes every minute when user is active
  useActiveTabInterval(60000, shouldRunActiveTabInterval);

  let routPath = location?.pathname;
  let authPath = routPath.split("/").find((item) => item === "auth") === "auth";

  const handleLogoutProcess = () => {
    expiredTokenHandler();
  };

  const handleRegisteredEmail = (email) => setRegisteredEmail(email);

  let localToken = JSON.parse(
    localStorage.getItem("aws-amplify-federatedInfo") || "null",
  )?.token;

  const readStoredUserData = () => {
    try {
      return JSON.parse(localStorage.getItem("aws-amplify-USERDATA") || "null");
    } catch (e) {
      return null;
    }
  };

  const readStoredToken = () => {
    try {
      return (
        JSON.parse(localStorage.getItem("aws-amplify-federatedInfo") || "null")
          ?.token ||
        JSON.parse(localStorage.getItem("aws-amplify-USERDATA") || "null")?.sub
      );
    } catch (e) {
      return undefined;
    }
  };

  const isMiniAuthPath = (path) =>
    path.includes("telegram-authentication") ||
    path.includes("mini-login") ||
    path.includes("mini-auth-confirm") ||
    path.includes("mini-resend-confirm");

  // After Android WebView restores __cc_auth_* backups, sync Redux (localStorage
  // updates do not trigger React re-renders).
  useEffect(() => {
    const syncFromStorage = () => {
      try {
        const raw = localStorage.getItem("aws-amplify-federatedInfo");
        if (!raw) return;
        const tok = JSON.parse(raw || "null")?.token;
        const ud = JSON.parse(
          localStorage.getItem("aws-amplify-USERDATA") || "null",
        );
        if (isValidSession(tok, ud)) {
          axios.defaults.headers.common["Authorization"] = `Bearer ${tok}`;
          dispatch(setToken(tok));
          dispatch(setUserData(ud));
        }
        if (localStorage.getItem("auth") !== "telegram") {
          const ab = localStorage.getItem("__cc_auth_auth");
          if (ab === "telegram" || (ab && String(ab).includes("telegram"))) {
            localStorage.setItem("auth", "telegram");
          }
        }
      } catch (e) {
        /* ignore */
      }
    };
    const onRestored = () => syncFromStorage();
    window.addEventListener("cc-auth-restored", onRestored);
    syncFromStorage();
    return () => window.removeEventListener("cc-auth-restored", onRestored);
  }, [dispatch]);

  // TODO: NOTE: this code edited based on the telegram authentication
  useEffect(() => {
    if (
      userData?.email &&
      !profileDataDispatched &&
      !location?.pathname?.includes("telegram") &&
      !location?.pathname?.includes("expired") &&
      !location.pathname.includes("refresh-session") &&
      !isRedirecting
    ) {
      dispatch(
        getProfileData(
          userData?.email,
          userData?.["custom:custom_username"],
          "fast",
        ),
      );
      setProfileDataDispatched(true);
    }
  }, [userData, profileDataDispatched, location, isRedirecting, dispatch]);

  // TODO: NOTE: this code edited based on the telegram authentication

  useEffect(() => {
    const path = location?.pathname || "";
    const isMiniAppRoute = path.startsWith("/mini-");

    if (
      !location?.pathname?.includes("telegram") &&
      (!localStorage.getItem("auth") ||
        localStorage.getItem("auth") !== "telegram") &&
      !location?.pathname?.includes("verify-location") &&
      !location.pathname.includes("refresh-session") &&
      !isRedirecting
    ) {
      if (localToken && !userData?.email) {
        const storedUser = readStoredUserData();
        if (isValidSession(localToken, storedUser)) {
          axios.defaults.headers.common["Authorization"] =
            `Bearer ${localToken}`;
          dispatch(setToken(localToken));
          dispatch(setUserData(storedUser));
        }
      }

      if (!localToken) {
        if (routPath !== "/" && !authPath) {
          // Never send Telegram mini-app / WebView to site root (/ -> /auth/login):
          // localStorage is often restored a few ms later from native backups.
          if (isMiniAppRoute) {
            const id = window.setTimeout(() => {
              let delayed;
              try {
                delayed = JSON.parse(
                  localStorage.getItem("aws-amplify-federatedInfo") || "null",
                )?.token;
              } catch (e) {
                delayed = undefined;
              }
              if (!delayed) {
                router("/telegram-authentication", { replace: true });
              }
            }, 900);
            return () => window.clearTimeout(id);
          }
          return router(`/`);
        }
      }

      if (localToken) {
        if (authPath) {
          // return router("/dashboard");
          return router("/welcome");
        }
      }
      if (!localToken) {
        if (authPath) {
          return router(routPath);
        }
        // return router(`/auth/login`);
      }
      if ((token || localToken) && authPath) {
        // return router("/dashboard");
        return router("/welcome");
      }
    }

    // tokenRefresh()
  }, [
    token,
    localToken,
    location.pathname,
    isRedirecting,
    userData?.email,
    authPath,
    dispatch,
    routPath,
    router,
  ]);

  // TODO: NOTE: this code added for the telegram authentication
  useEffect(() => {
    if (location?.pathname?.includes("telegram")) {
      // localStorage.clear();
      clearLocalStorage();

      const telegramAuth = params.get("tgWebAppStartParam");
      if (telegramAuth) {
        dispatch(saveTelegramAuthData(telegramAuth));
      }

      dispatch(setLoginProcessToTelegram());
      localStorage.setItem("auth", "telegram");
    }
  }, [dispatch, location, params]);

  // TODO: NOTE: this code added for the telegram authentication
  useEffect(() => {
    if (localStorage.getItem("auth") !== "telegram") return;
    dispatch(setLoginProcessToTelegram());
    const storedUser = readStoredUserData();
    const storedToken = readStoredToken();
    if (!isValidSession(storedToken, storedUser)) return;
    dispatch(setUserData(storedUser));
    dispatch(setToken(storedToken));
    axios.defaults.headers.common["Authorization"] = `${storedToken}`;
  }, []);

  const sessionLogoutRef = useRef(false);
  useEffect(() => {
    const path = location?.pathname || "";
    if (isMiniAuthPath(path)) return;
    const miniProtected = path.startsWith("/mini-");
    if (!miniProtected) return;
    if (sessionLogoutRef.current) return;
    const storedUser = isValidUserData(userData)
      ? userData
      : readStoredUserData();
    const storedToken = localToken || token || readStoredToken();
    if (isValidSession(storedToken, storedUser)) return;
    sessionLogoutRef.current = true;
    if (localStorage.getItem("auth") !== "telegram") {
      localStorage.setItem("auth", "telegram");
    }
    expiredTokenHandler();
  }, [location.pathname, localToken, token, userData]);

  // Define a ref variable to store the start time
  const startTimeRef = useRef(null);

  // Define a function to get the current time in the desired format
  const getCurrentTime = () => {
    return moment().format("YYYY-MM-DD HH:mm:ss");
  };

  // Use the useEffect hook to update the start time when the location changes
  useEffect(() => {
    startTimeRef.current = getCurrentTime();
  }, [location.pathname]);

  // Use another useEffect hook to send the post request when the component unmounts
  useEffect(() => {
    // Define a cleanup function
    const cleanup = () => {
      // Get the end time
      const endTime = getCurrentTime();
      // Get the start time from the ref variable
      const startTime = startTimeRef.current;
      // Calculate the duration in seconds
      const duration = moment(endTime).diff(moment(startTime), "seconds");
      // Send the post request with the user data and the duration
      if (userData?.sub && data?.ip_address && duration > 0) {
        axios.post(
          "https://5k9w3fozlg.execute-api.ap-southeast-2.amazonaws.com/dev/api",
          {
            url: location.pathname,
            ip: data?.ip_address,
            duration: duration,
            visit_time: endTime,
            email: userData?.email,
            user: userData?.["custom:custom_username"],
          },
        );
      }
    };
    // Return the cleanup function from the useEffect hook
    return cleanup;
  }, [location.pathname, data, userData]);

  useEffect(() => {
    if (window.performance) {
      if (
        window.performance.navigation.type === "reload" ||
        window.performance.navigation.type === 1
      ) {
        localStorage.removeItem("dashboardStatus");
        localStorage.removeItem("assistantAtatus");
        localStorage.removeItem("selectedPortfolioExchange");
      }
    }
  }, []);
  useEffect(() => {
    localStorage.removeItem("dashboardStatus");
    localStorage.removeItem("assistantAtatus");
    localStorage.removeItem("selectedPortfolioExchange");
  }, []);
  // TODO: NOTE: this code edited based on the telegram authentication
  useEffect(() => {
    if (
      userData &&
      userData.email &&
      !location.pathname.includes("refresh-session") &&
      !isRedirecting
    ) {
      // Set up an interval to execute a function every 30 minutes
      const intervalId = setInterval(
        async () => {
          await axios
            .post(
              "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api",
              { platform_mode: "check_expiration" },
            )
            .then((res) => {
              if (res?.data?.has_expired !== "No") {
                handleLogoutProcess();
              }
            })
            .catch((err) => {
              handleLogoutProcess();
            });
        },
        30 * 60 * 1000,
      );

      // Clear the interval when the component unmounts or when userData changes
      return () => clearInterval(intervalId);
    }
  }, [
    dispatch,
    handleLogoutProcess,
    isRedirecting,
    location.pathname,
    userData,
  ]);

  useEffect(() => {
    if (
      location?.pathname?.includes("telegram") &&
      localStorage.getItem("telegram-auth-data")
    ) {
      const telegramAuth = JSON.parse(
        localStorage.getItem("telegram-auth-data") || "null",
      );
      dispatch(saveTelegramAuthData(telegramAuth));
    }
  }, []);

  // useEffect(() => {
  //   if (profileData.user) {
  //     if (
  //       !profileData?.suggested_features &&
  //       !updateLoading &&
  //       localStorage.getItem("auth") !== "telegram"
  //     ) {
  //       router("/start-wizard");
  //     }
  //   }
  // }, [profileData]);

  useEffect(() => {
    dispatch(getPricingPlan());
  }, []);

  useEffect(() => {
    if (
      userData &&
      Object.keys(userData ?? {})?.length &&
      !trustedIps.length &&
      getTrustedIpsStatus !== "error" &&
      getTrustedIpsStatus !== "loading" &&
      token &&
      !location.pathname.includes("refresh-session") &&
      !isRedirecting
    ) {
      dispatch(getTrustedIps());
    }
  }, [
    dispatch,
    trustedIps,
    userData,
    getTrustedIpsStatus,
    token,
    location.pathname,
    isRedirecting,
  ]);

  useEffect(() => {
    if (
      userData?.email &&
      !telegramBotToken &&
      telegramBotTokenStatus !== "error" &&
      telegramBotTokenStatus !== "loading" &&
      !location.pathname.includes("refresh-session") &&
      !isRedirecting
    ) {
      dispatch(
        getTelegramBotToken(
          userData?.email,
          userData?.["custom:custom_username"],
        ),
      );
    }
  }, [
    dispatch,
    location.pathname,
    telegramBotToken,
    telegramBotTokenStatus,
    userData,
    isRedirecting,
  ]);

  useEffect(() => {
    if (localStorage.getItem("auth") === "telegram") {
      const tg = window?.Telegram?.WebApp;
      tg?.setHeaderColor("#0C359E");
      const goBack = () => {
        router(-1);
      };
      tg?.BackButton?.show();
      tg?.BackButton?.onClick(goBack);
    }
  }, []);

  return (
    <>
      <Routes>
        {/*MINI APP ROUTES*/}
        <Route
          path="/mini-login"
          element={<Navigate replace to="/telegram-authentication" />}
        />
        <Route path="/mini-auth-confirm" element={<MiniAppConfirmPage />} />
        <Route
          path="/mini-resend-confirm"
          element={<MiniAppResendConfirmationCode />}
        />
        <Route path={"/mini-dashboard"} element={<MiniPortfolio />} />
        {/*PREV ROUTE IN MINI APP*/}
        {/*<Route path={"/mini-dashboard"} element={<MiniDashboard />} />*/}
        <Route path={"/mini-ai-signals"} element={<MiniAISignals />} />
        {/*PREV ROUTE IN MINI APP*/}
        {/*<Route path={"/mini-create-bot"} element={<CreateBotProcess />} />*/}
        <Route path={"/mini-create-bot"} element={<MiniBots />} />
        <Route path={"/mini-all-bots"} element={<MiniAppAllBots />} />
        <Route path={"/mini-bots"} element={<MiniBots />} />
        <Route path={"/mini-portfolio"} element={<MiniPortfolio />} />
        <Route path={"/mini-settings"} element={<MiniSettings />} />
        <Route path={"/mini-community-bots"} element={<MiniBotsPool />} />

        <Route path={"/mini-pricing-plan"} element={<MiniPricingPlan />}>
          <Route path={":section"} element={<MiniPricingPlan />} />
        </Route>
        {/*MINI APP ROUTES*/}
        <Route path={"/refresh-token"} element={<TokenExpired />} />
        {/*TELEGRAM AUTHENTICATION*/}
        <Route
          path={"/telegram-authentication"}
          element={<TelegramAuthentication />}
        ></Route>

        {/*--------------VERIFY USER LOCATION-------------*/}
        <Route path={"/verify-location"} element={<VerifyUserLocation />} />
        {/*--------------VERIFY USER LOCATION-------------*/}

        <Route path="/welcome" element={<WelcomePage />} />
        {/* EXCHANGES ROUTE */}
        <Route path="/portfolio" element={<ExchangePortfolio />} />
        {/* EXPIRATION ROUTE */}
        <Route path="/expired-account" element={<ExpiredPage />} />

        <Route path="/start-wizard" element={<StartWizard />} />

        {/*dashboard*/}
        <Route path="/dashboard" element={<NewDashboard />} />
        <Route path="/dashboard/:section" element={<NewDashboard />} />
        {/*/>*/}

        <Route path="/Insight" element={<NewInsight />}>
          <Route path=":section" element={<NewInsight />} />
        </Route>

        {/*BOT SECTION*/}
        <Route path={"/bot-automation"} element={<BotAndAutomation />} />
        <Route
          path={"/bot-automation/:section"}
          element={<BotAndAutomation />}
        />
        {/*<Route*/}
        {/*    path={"/bot-automation/bot-performance/report"}*/}
        {/*    element={<PdfReport/>}*/}
        {/*/>*/}
        {/*<Route*/}
        {/*    path={"/bot-automation/bot-performance/report/:id"}*/}
        {/*    element={<PdfReport/>}*/}
        {/*/>*/}
        <Route
          path={"/bot-automation/backtest/report"}
          element={<BacktestReport />}
        />
        <Route
          path={"/bot-automation/backtest/report/:id"}
          element={<BacktestReport />}
        />
        <Route path={"/pricing-billing"} element={<PricingBillingIndex />}>
          <Route path=":section" element={<PricingBillingIndex />} />
        </Route>

        {/*developer-api*/}
        <Route path="/developer-api" element={<DeveloperApi />} />
        {/*trade assistant*/}

        <Route path={"/ai-assistant"} element={<TradeAssistant />} />
        <Route path="/ai-assistant/:section" element={<TradeAssistant />} />

        {/*trade simulator*/}
        {/* <Route path="/trade-simulator" element={<TradeSimulator />} /> */}
        <Route path="/trade-simulator" element={<ComingSoon />} />
        {/*alert system*/}
        <Route path="/alert-system/:section" element={<AlertSystem />} />
        <Route path="/alert-system" element={<AlertSystem />} />
        <Route
          path="/alert-system/previous-email/:id"
          element={<PreviousEmail />}
        />
        {/*help & feedback*/}
        <Route path="/faq/:section" element={<Help />} />
        {/*profile page*/}
        <Route path="/profile/:section" element={<Profile />} />

        {/*------REFRESH COGNITO TOKEN------*/}
        <Route path="/refresh-session" element={<RefreshToken />} />

        {/*REDIRECTION AUTHENTICATE*/}
        <Route path="/redirect" element={<AuthRedirectProcess />} />
        {/*auth*/}
        <Route
          path="/auth/signup/:code"
          element={<SignUpPage emailHandler={handleRegisteredEmail} />}
        />
        <Route
          path="/auth/signup"
          element={<SignUpPage emailHandler={handleRegisteredEmail} />}
        />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/*" element={<LoginPage />} />
        <Route
          path="/auth/confirm"
          element={<Confirm registeredEmail={registeredEmail} />}
        />
        <Route path="/auth/forgotPassword" element={<ForgotPassword />} />
        <Route path="/" element={<Navigate replace to="/auth/login" />} />
      </Routes>
      {!authPath && <RatingModal />}
      <ToastContainer position="bottom-center" />
    </>
  );
}

export default App;
